import { render } from "./Header.vue?vue&type=template&id=f60a6b3a&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=f60a6b3a&scoped=true&lang=css"

import exportComponent from "/Users/prateekjha/Projects/movie-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60a6b3a"]])

export default __exports__